<script setup lang="ts">
  import { useRouter } from "vue-router";
  import ProgressSpinner from "primevue/progressspinner";
  import { icons } from "@/assets/svg";
  import { Button } from "@/ui";

  const { ArrowLeftIcon } = icons;
  const router = useRouter();
  withDefaults(
    defineProps<{
      title: string;
      isLoading?: boolean;
      isWithBackButton?: boolean;
    }>(),
    {
      isLoading: false,
      isWithBackButton: false,
    },
  );
</script>

<template>
  <div class="md:flex-none flex flex-1 gap-8 md:p-8 p-0 rounded-lg mb-[100px] md:mb-0">
    <router-link :to="{ name: 'settings' }" class="top-6 left-6 md:hidden absolute inline-flex items-center gap-2">
      <ArrowLeftIcon class="w-auto h-4 fill-current" />
      <span class="text-14">Terug</span>
    </router-link>
    <div class="flex flex-col w-full h-full md:p-10 md:flex-none flex-1 gap-8 px-6 pt-16 pb-6 rounded-lg mb-0 bg-white">
      <div class="flex items-start justify-between">
        <div class="flex items-center gap-3">
          <Button v-if="isWithBackButton" icon="pi pi-arrow-left" @click="router.go(-1)" outlined />
          <h2 class="text-24 inline-block font-semibold">{{ title }}</h2>
        </div>
        <slot name="cta"></slot>
      </div>

      <div class="sm:-mx-6 md:-mx-8 -my-2 overflow-x-auto">
        <div class="sm:px-6 md:px-8 inline-block min-w-full py-2 align-middle">
          <div class="overflow-hidden">
            <div v-if="isLoading" class="flex justify-center items-center h-full">
              <ProgressSpinner />
            </div>
            <div v-else>
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
